module.exports = {
  "name": "@souche-f2e/souche-menu-partner",
  "version": "2.7.0-1",
  "description": "",
  "main": "lib/index.js",
  "types": "types/index.d.js",
  "scripts": {
    "dev": "cd docs-src && parcel index.html",
    "watch": "npm run build -- --watch",
    "build": "rm -rf lib && tsc",
    "build:docs": "rm -rf docs && cd docs-src && parcel build index.html -d ../docs --public-url ./ --no-minify && npm run build:typedoc",
    "build:esdoc": "esdoc",
    "build:typedoc": "typedoc src --out docs/typedoc --module uuid/v1,debug",
    "prepare": "npm t && npm run build",
    "postpublish": "npm run build:docs && sw publish dev",
    "test": "jest"
  },
  "author": "",
  "license": "ISC",
  "devDependencies": {
    "@babel/cli": "^7.5.5",
    "@babel/core": "^7.5.5",
    "@babel/plugin-proposal-class-properties": "^7.5.5",
    "@types/jest": "^24.0.18",
    "@types/uuid": "^3.4.5",
    "@types/vue": "^2.0.0",
    "@vue/component-compiler-utils": "^2.6.0",
    "axios": "^0.18.1",
    "conventional-changelog": "^3.1.10",
    "conventional-changelog-cli": "^2.0.23",
    "cz-conventional-changelog": "^2.1.0",
    "esdoc-ecmascript-proposal-plugin": "^1.0.0",
    "esdoc-standard-plugin": "^1.0.0",
    "highlight.js": "^9.15.9",
    "jest": "^24.9.0",
    "less": "^3.10.1",
    "markdown-it": "^8.4.2",
    "markdown-it-checkbox": "^1.1.0",
    "mockjs": "^1.0.1-beta3",
    "parcel-bundler": "^1.12.3",
    "ts-jest": "^24.0.2",
    "typedoc": "^0.14.2",
    "typescript": "^3.5.3",
    "vue": "^2.6.10",
    "vue-hot-reload-api": "^2.3.3",
    "vue-template-compiler": "^2.6.10"
  },
  "dependencies": {
    "debug": "^4.1.1",
    "nanoid": "^2.0.4",
    "permeator-core": "^1.1.2"
  },
  "config": {
    "commitizen": {
      "path": "./node_modules/cz-conventional-changelog"
    }
  }
}
;